import React from 'react';
import Card from 'react-bootstrap/Card';

const DomainCard = ({ domain, backlinks = [] }) => {
  return (
    <Card>
      <Card.Body>
        {!domain ? (
          <span>לא נבחר אתר</span>
        ) : (
          <>
            <div>
              לאתר{' '}
              <a href={domain} target={'_blank'}>
                {domain}
              </a>{' '}
              יש כבר {backlinks.length} אתרים שמקשרים אליו
            </div>
            <div>
              {backlinks.map(({ domain, categories }, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.3rem',
                    alignItems: 'center',
                  }}
                >
                  <span>
                    <a href={domain} target={'_blank'}>
                      {domain}
                    </a>
                  </span>
                  <span>
                    ({categories.map(({ name }) => name).join(', ')})
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default DomainCard;
